export default "__VITE_PUBLIC_ASSET__c690dd9c__"